<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <FaceCapture :accessId="accessId" :client="client" @cancel="close" />
  </v-dialog>
</template>

<script>
import FaceCapture from "../../global/FaceCapture.vue";

export default {
  components: {
    FaceCapture,
  },
  data() {
    return {
      accessId: "",
      client: null,
      dialog: false,
    };
  },
  methods: {
    open({ accessId, client }) {
      this.accessId = accessId;
      this.client = client;
      this.dialog = true;
    },
    close() {
      this.accessId = "";
      this.client = null;
      this.dialog = false;
    },
  },
  mounted() {
    this.$root.$on("face-capture-modal", this.open);
  },
  beforeDestroy() {
    this.$root.$off("face-capture-modal", this.open);
  },
};
</script>
